// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumEnvironmentEventType = {
  EnvEventTypeUpsert: 'UPSERT',
  EnvEventTypeUpserted: 'UPSERTED',
  EnvEventTypeDelete: 'DELETE',
  EnvEventTypeDeleted: 'DELETED',
  EnvEventTypeScaleUp: 'SCALE_UP',
  EnvEventTypeScaledUp: 'SCALED_UP',
  EnvEventTypeScaleDown: 'SCALE_DOWN',
  EnvEventTypeScaledDown: 'SCALED_DOWN',
} as const;
export type EnumEnvironmentEventType =
  (typeof EnumEnvironmentEventType)[keyof typeof EnumEnvironmentEventType];

export function instanceOfEnumEnvironmentEventType(value: any): boolean {
  for (const key in EnumEnvironmentEventType) {
    if (Object.prototype.hasOwnProperty.call(EnumEnvironmentEventType, key)) {
      if (
        EnumEnvironmentEventType[
          key as keyof typeof EnumEnvironmentEventType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumEnvironmentEventTypeFromJSON(
  json: any,
): EnumEnvironmentEventType {
  return EnumEnvironmentEventTypeFromJSONTyped(json, false);
}

export function EnumEnvironmentEventTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentEventType {
  return json as EnumEnvironmentEventType;
}

export function EnumEnvironmentEventTypeToJSON(
  value?: EnumEnvironmentEventType | null,
): any {
  return value as any;
}

export function EnumEnvironmentEventTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentEventType {
  return value as EnumEnvironmentEventType;
}
